import styled from "styled-components";

export const StyledCurrentDevice: any = styled.div`
  ${({ theme, mobileView }: any & { mobileView?: any }) => `
    .title {
      font-size: ${theme.uptimeFontSizes.desktop.fz6}px;
      font-weight: 600;
      margin: ${theme.uptimeSpace[5]}px 0;
      line-height: normal;
    }

    .current-device-container {
      display: flex;
      flex-direction: ${mobileView.smUp ? "row" : "column"};
      flex-wrap: nowrap;
      align-items: center;
      padding: ${theme.uptimeSpace[10]}px;
      &.background-default {
        background-color: ${theme.uptimeColors.grayScales.white} !important;
        box-shadow: ${theme.uptimeColors.grayScales.lightGray} -4px 4px !important;
        border: solid 1px ${theme.uptimeColors.grayScales.lightGray};
      }   
      &.background-empty {
        box-shadow: 4px 10px 30px 4px rgb(36 14 47 / 6%) !important;       
        border-radius: 8px;
        border: 1px solid ${theme.uptimeColors.grayScales.lightGray};
      }

      .device-image-container,
      .device-spec-container {
        display: flex;
        flex-direction: column;
      }

      .device-image-container {
        flex: 1;
        max-width: 200px;        
        justify-content: center;
        align-items: flex-start;
        &.align-items-center {            
          align-items: center;
        }          
        img {
          width: 200px;
          display: block;
        }
      }

      .device-spec-container {
        flex: 2;
        align-items: ${mobileView.xsUp ? "unset" : "flex-start"};
        padding-left: ${mobileView.smUp ? theme.uptimeSpace[10] : theme.uptimeSpace[0]}px;
        .device-model {
          line-height: normal !important;
          font-weight: 600;
          .manufacturer {
            font-size: ${theme.uptimeFontSizes.desktop.fz6}px;
            text-transform: uppercase;
          }
          .model {
            padding-left: ${theme.uptimeSpace[5]}px;
          }
        }

        .specification {
          font-size: ${theme.uptimeFontSizes.desktop.fz2}px;
          font-weight: 500;
          padding: ${theme.uptimeSpace[6]}px ${theme.uptimeSpace[0]} ${theme.uptimeSpace[7]}px;
          line-height: normal;
        }

        .specification-content {
          display: grid;
          gap: 1rem;
          &.columns-2 {
            margin-top: ${theme.uptimeSpace[10]}px;
            grid-template-columns: repeat(1, minmax(0,1fr)) !important;
            max-width: 360px;
            min-width: 240px;

            &.show-keyboard {
              grid-template-columns: repeat(2, minmax(0,1fr)) !important;
            }
          }
          &.columns-3 {
            grid-template-columns: repeat(${mobileView.smUp ? '3' : mobileView.xsUp ? '2' : '1'}, minmax(0,1fr)) !important;  
            min-width: ${mobileView.xsUp ? 'unset' : '200px'};
          }

          .spec-details {
            font-size: ${theme.uptimeFontSizes.desktop.fz2}px;
            display: flex;
            align-items: center;
            border-radius: 6px;
            overflow: hidden;
            border: 1px solid ${theme.uptimeColors.grayScales.lightGray};
            min-height: 35px;
            background-color: ${theme.uptimeColors.grayScales.grayish};

            .spec-value {
              height: 100%;
              display: block;
              padding: ${theme.uptimeSpace[4]}px ${theme.uptimeSpace[5]}px;
              font-weight: 500;
              font-size: ${theme.uptimeFontSizes.desktop.fz2}px;
              line-height: ${theme.uptimeLineHeights.desktop.lh3}px;
              background-color: ${theme.uptimeColors.grayScales.grayish};
              border-left: 1px solid ${theme.uptimeColors.grayScales.lightGray};
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              
            }

            .spec-icon {
              width: 30px;
              min-width: 30px;
              padding: ${theme.uptimeSpace[2]}px;
              color: ${theme.uptimeColors.mainTheme.primary};
            }
          }
        }
      }
    }     
  `}
`;
